export const emptyText = "--/--";
